import { useLocation } from 'react-router-dom';
import { AuthExpiredError } from '@/lib/fetch-utils';
import { useBanner } from '@/hooks/useBanner';
import { useSyncActivity } from '@/hooks/useSyncActivity';
import { isAuthRoute, SESSION_EXPIRED_MESSAGE } from './messages';

/** Posts "sign in again" while the last sync failed on an expired session. */
export function useSessionExpiredBanner(): void {
  const { status, lastError } = useSyncActivity();
  const { pathname } = useLocation();
  useBanner(
    status === 'error' && lastError instanceof AuthExpiredError && !isAuthRoute(pathname)
      ? SESSION_EXPIRED_MESSAGE
      : null,
  );
}
